export default "__VITE_ASSET__Fg_8RJSAjCCbRcVpcV7dIQ__"